import { render } from "./ProviderRequestsModal.vue?vue&type=template&id=8d97d63a&ts=true"
import script from "./ProviderRequestsModal.vue?vue&type=script&lang=ts"
export * from "./ProviderRequestsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__